import CustomLayout from "./wrapPageElement"

export const wrapPageElement = CustomLayout